module.exports = new __parcel__URL__("CineBriqueVF.03592e24.webp").toString();